import { createAsyncThunk } from "@reduxjs/toolkit";
// Types
import Reducers from "types/Reducers";
// Models
import IQuiz from "models/Quiz";
// Async
import { getQuizEvents } from "store/quizEvents/quizEventsAsync";
// Actions
import { setResultId, setUserId } from 'store/auth/authSlice';
import { setAppSyncEventsConfig } from "store/ui/uiSlice";
import { setExistingPlayer } from "store/player/playerSlice";
// Services
import StorageService from "services/Storage.service";
// Utilities
import fetcher from "utilities/Fetcher";
import { decodeBase64 } from 'utilities/Utilities';

const _url:string = '/player/quiz';

// Get pages
export const getQuiz = createAsyncThunk(
  `${Reducers.Quiz}/Get quiz`,
  async (slug:string, { dispatch, rejectWithValue, fulfillWithValue }) => {
    const response:Response = await fetcher(`${_url}/${slug}`, {
      method: 'GET'
    });
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    const { quiz:quizHash, result:resultHash, player:playerHash, appSyncEventsConfig } = await response.json();

    const quiz:IQuiz = decodeBase64(quizHash);

    dispatch(getQuizEvents(quiz._id));

    // Set quiz nonce into storage
    StorageService.setNonce(quiz.nonce);

    if ( resultHash ){
      const { id:resultId, user:userId } = decodeBase64(resultHash);
      if ( resultId ){
        if ( userId ){
          dispatch(setUserId(userId));
          StorageService.setQwid(userId);
        }
        dispatch(setResultId(resultId));
      }
    }

    if ( playerHash ) {
      const player = decodeBase64(playerHash);
      dispatch(setExistingPlayer(player));
      if (quiz.registrationPage && quiz.registrationPage.anonymous && quiz.registrationPage.useExistingPlayer && player.email.endsWith('@anonymous')) {
        dispatch(setUserId(player.id));
      }
    }

    if ( appSyncEventsConfig ) {
      dispatch(setAppSyncEventsConfig({ ...decodeBase64(appSyncEventsConfig), quizId: quiz._id }));
    }

    return fulfillWithValue(quiz);
  }
);